export const languages = [
	{
		locale: 'de-DE',
		href: 'https://de.audionetwork.com',
		language: 'Deutsch',
		region: 'Deutschland',
	},
	{
		locale: 'en-GB',
		href: 'https://www.audionetwork.com',
		language: 'English',
		region: 'United Kingdom',
	},
	{
		locale: 'en-US',
		href: 'https://us.audionetwork.com',
		language: 'English',
		region: 'United States',
	},
	{
		locale: 'en-AU',
		href: 'https://au.audionetwork.com',
		language: 'English',
		region: 'Australia',
	},
	{
		locale: 'es-ES',
		href: 'https://es.audionetwork.com',
		language: 'Español',
		region: 'España',
	},
	{
		locale: 'fr-FR',
		href: 'https://fr.audionetwork.com',
		language: 'Français',
		region: 'France',
	},
	{
		locale: 'it-IT',
		href: 'https://it.audionetwork.com',
		language: 'Italiano',
		region: 'Italia',
	},
	{
		locale: 'pt-PT',
		href: 'https://pt.audionetwork.com',
		language: 'Português',
		region: 'Portugal',
	},
	{
		locale: 'ja-JP',
		href: 'https://jp.audionetwork.com',
		language: '日本語',
		region: '日本',
		// Add aria labels for JP and CN because screen readers can't always read JP/CN scripts
		ariaLabel: '日本語 日本 Nihongo (Nihon)',
	},
	{
		locale: 'zh-CN',
		href: 'https://cn.audionetwork.com',
		language: '简体中文',
		region: '中国',
		ariaLabel: '简体中文 中国 Jiǎntǐ zhōngwén (Zhōngguó)',
	},
]
